module.exports = __webpack_public_path__ + "static/laptop-0c5266b463c27df628e6ba27f05c441f.png";